import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a6e2c6c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-manage-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  class: "flex align-center"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, " 用户名/手机号：", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "用户类型：", -1));
const _hoisted_6 = {
  style: {
    "width": "250px"
  }
};
const _hoisted_7 = {
  style: {
    "margin-left": "20px"
  }
};
import { delUser, getUserManageList } from '@/api/user';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref, watch } from 'vue';
import RolesDialog from './components/roles';
import Table from './components/table.vue';
import { USER_OPTIONS } from './config';
import { Search, Refresh } from '@element-plus/icons-vue';
import AddDialog from './components/add';
export default {
  __name: 'index',
  setup(__props) {
    const searchType = ref(1);

    // 数据相关
    const tableData = ref([]);
    const total = ref(0);
    const page = ref(1);
    const size = ref(8);
    const keyword = ref('');
    const loading = ref(false);
    // 获取数据的方法
    const getListData = async () => {
      loading.value = true;
      const result = await getUserManageList({
        currentPage: page.value,
        pageSize: size.value,
        searchType: searchType.value === -1 ? '' : searchType.value,
        keyword: keyword.value
      });
      tableData.value = result.records;
      total.value = result.total;
      loading.value = false;
    };
    getListData();
    const handleSearch = () => {
      page.value = 1;
      getListData();
    };
    const handleRefresh = async () => {
      searchType.value = 1;
      page.value = 1;
      keyword.value = '';
      await getListData();
    };
    const handleCurrentChange = val => {
      page.value = val;
      getListData();
    };
    const dialogVisible = ref(false);
    const current = ref(null);
    const addUserHandler = () => {
      dialogVisible.value = true;
    };
    const handleUpdateUser = row => {
      current.value = row;
      dialogVisible.value = true;
    };
    const delUserHandler = row => {
      ElMessageBox.confirm('确认要删除吗', {
        type: 'warning'
      }).then(async () => {
        try {
          await delUser(row.id);
          ElMessage.success('删除成功');
          // 重新渲染数据
          getListData();
        } catch (error) {
          ElMessage({
            message: error,
            type: 'error'
          });
        }
      });
    };

    /**
     * 查看角色的点击事件
     */
    const selectUserId = ref('');
    const roleDialogVisible = ref(false);
    const onShowRoleClick = row => {
      selectUserId.value = row.id;
      roleDialogVisible.value = true;
    };

    // 保证每次打开重新获取用户角色数据
    watch(roleDialogVisible, val => {
      if (!val) selectUserId.value = '';
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
          placeholder: "请输入关键字",
          style: {
            "width": "250px",
            "margin-right": "20px"
          }
        }, null, 8, ["modelValue"]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_select, {
          modelValue: searchType.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchType.value = $event),
          class: "m-2",
          placeholder: "选择用户类型"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(USER_OPTIONS), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: handleSearch
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addUserHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['userAdd']]])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createVNode(Table, {
          data: tableData.value,
          page: page.value,
          size: size.value,
          total: total.value,
          onOnShowRoleClick: onShowRoleClick,
          onDelUserHandler: delUserHandler,
          onHandleCurrentChange: handleCurrentChange,
          onUpdateUser: handleUpdateUser,
          type: searchType.value,
          loading: loading.value
        }, null, 8, ["data", "page", "size", "total", "type", "loading"])]),
        _: 1
      }), _createVNode(_unref(RolesDialog), {
        modelValue: roleDialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => roleDialogVisible.value = $event),
        userId: selectUserId.value,
        onUpdateRole: getListData
      }, null, 8, ["modelValue", "userId"]), _createVNode(_unref(AddDialog), {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogVisible.value = $event),
        onGetData: getListData,
        model: current.value,
        onClearModel: _cache[4] || (_cache[4] = $event => current.value = null)
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};